import React from "react";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { Button } from "@design-system/Button/Button";
import { DocumentPeriodSelector } from "../DocumentPeriodSelector/DocumentPeriodSelector";
import { getDocumentLockedTooltip } from "../lib";
import { formatDocumentPeriod } from "../formatDocumentPeriod";
import { MetadataItem } from "./MetadataItem";
import styles from "./FinancialDocumentMetadata.module.scss";

interface Props {
    financialDocument: FinancialDocumentExtended;
}

export const PeriodField: React.FC<Readonly<Props>> = ({
    financialDocument,
}) => {
    const lockedTooltip = getDocumentLockedTooltip(
        financialDocument,
        financialDocument.integrationAccount ?? null,
    );
    const period = formatDocumentPeriod(financialDocument.taxonomyExtraction);

    if (lockedTooltip) {
        if (!period) {
            return null;
        }
        return (
            <MetadataItem label="Period">
                <Tooltip content={lockedTooltip}>
                    <span>{period}</span>
                </Tooltip>
            </MetadataItem>
        );
    }

    return (
        <MetadataItem label="Period">
            <DocumentPeriodSelector financialDocument={financialDocument}>
                <Button
                    variant="secondary"
                    size="md"
                    className={styles.periodTrigger}
                >
                    {period ?? "Set period"}
                </Button>
            </DocumentPeriodSelector>
        </MetadataItem>
    );
};
